export default "__VITE_ASSET__CmAe82HK__"